import { WidgetDirectivesRepository } from '../../directives/WidgetDirectivesRepository';
import { PdfVisibilityDirectiveType } from '../../directives/pdf-visibility/PdfVisibilityDirective.type';
import { WidgetRepository } from './WidgetRepository';
import { getAllWidgetTypes } from './getAllWidgetTypes';

/**
 * Soluzione per evitare di eseguire il codice di inizializzazione manualmente
 * in ogni metodo della classe.
 * Non possiamo eseguirlo direttamente nel costruttore per via delle dipendenze
 * circolari.
 */
export function initWidgetRepository() {
  if (WidgetRepository.isInitialized) {
    return;
  }

  getAllWidgetTypes().forEach(type => WidgetRepository.register(type));
  WidgetRepository.isInitialized = true;

  /**
   *  DIRETTIVE
   */

  /**
   * Visibilità del campo in compilazione/pdf
   */
  WidgetDirectivesRepository.register(PdfVisibilityDirectiveType);
}
